// extracted by mini-css-extract-plugin
module.exports = {"returns":"_72de1b9","description":"_9414542","value":"_7876faa","returnValue":"_edaa182","returnValuePriceChange":"_545ee71","bonusCash":"_7a406be"};